import { Domain } from '_graphql/cache/auth'
import React from 'react'
import { getDomain } from 'router/filter'

type Props = {
    children: React.ReactNode,
    domains: Domain[]
    condition?: boolean
}

const FeatureWrap: React.FC<Props> = ({ children, domains, condition = true }) => {
    const domain = getDomain();
    const isDomainAllowed = domains.includes(domain);
    // console.log('isDomainAllowed', isDomainAllowed, domain, domains)
    if (!isDomainAllowed) {
        return null;
    }
    if (condition === false) {
        return null;
    }
    return <>{children}</>;
}

export default FeatureWrap